(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/session-end-message/assets/javascripts/session-end-message.js') >= 0) return;  svs.modules.push('/components/components/session-end-message/assets/javascripts/session-end-message.js'); (function(svs) {
  svs.components = svs.components || {};
  svs.components.session_end_message =
    svs.components.session_end_message ||
    (function() {
      var logger = svs.core.log.getLogger('components:session-end-message'),
        START_TIME_FOR_SHOWING_MESSAGE = 45 * 60 * 1000,
        SESSION_TIME = 60 * 60 * 1000,
        SAFETY_MARGIN = 60 * 1000,
        CHECK_SESSION_END_TIME = 30 * 1000,
        lastSuccessfullCallTime = new Date().getTime(),
        showMsgTimeoutID,
        closeMsgTimeoutID,
        sessionEndTime = new Date().getTime() + SESSION_TIME,
        logUnauthorizedResponse = true,
        responseHandler,
        isNativeApp = svs.utils.ns.isNamespace(
          'svs.core.config.data.svsconfig.isNativeApp'
        )
          ? svs.core.config.data.svsconfig.isNativeApp
          : false;

      function checkAndShowMessage() {
        var currentTime = new Date().getTime();
        if (
          sessionEndTime - currentTime <
          SESSION_TIME - START_TIME_FOR_SHOWING_MESSAGE
        ) {
          show();
        } else {
          logger.debug(
            'Time left before showing session end message: ' +
            Math.floor(
              (sessionEndTime -
                currentTime -
                (SESSION_TIME - START_TIME_FOR_SHOWING_MESSAGE)) /
              1000
            ) +
            ' s'
          );
          showMsgTimeoutID = window.setTimeout(
            checkAndShowMessage,
            CHECK_SESSION_END_TIME
          );
        }
      }

      function checkAndCloseMessage() {
        var currentTime = new Date().getTime();
        if (sessionEndTime - currentTime < 2 * SAFETY_MARGIN) {
          close();
        } else {
          logger.debug(
            'Time left before closing session end message without user interaction: ' +
            Math.floor(
              (sessionEndTime - currentTime - 2 * SAFETY_MARGIN) / 1000
            ) +
            ' s'
          );
          closeMsgTimeoutID = window.setTimeout(
            checkAndCloseMessage,
            CHECK_SESSION_END_TIME
          );
        }
      }

      function updateSessionTimers() {
        if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
          clearTimeout(showMsgTimeoutID);
          if (isNativeApp) {
            showMsgTimeoutID = window.setTimeout(
              checkAndShowMessage,
              Math.min(CHECK_SESSION_END_TIME, START_TIME_FOR_SHOWING_MESSAGE)
            ); 
          } else {
            showMsgTimeoutID = window.setTimeout(
              show,
              START_TIME_FOR_SHOWING_MESSAGE
            );
          }
          sessionEndTime = new Date().getTime() + SESSION_TIME;
          lastSuccessfullCallTime = new Date().getTime();
        }
      }

      function clearSessionTimers() {
        clearTimeout(showMsgTimeoutID);
        clearTimeout(closeMsgTimeoutID);
        sessionEndTime = new Date().getTime();
        lastSuccessfullCallTime = new Date().getTime();
      }
      function logLastSuccessfulCall() {
        if (logUnauthorizedResponse) {
          svs.components.analytics.trackEvent({
            category: 'Users',
            action: 'Session',
            opt_label: 'SessionExpired',
            opt_value: Math.floor(
              (new Date().getTime() - lastSuccessfullCallTime) / 1000
            )
          });
          logUnauthorizedResponse = false;
        }
      }

      function responseEvent(statusCode) {
        switch (statusCode) {
          case 200:
            logUnauthorizedResponse = true;
            updateSessionTimers();
            break;
          case 401:
            logLastSuccessfulCall();
            clearSessionTimers();
            break;
          default:
            logger.debug('Unhandled response code: ' + statusCode);
        }
      }

      function init(test) {
        if (!responseHandler) {
          responseHandler = svs.events.subscribe(
            '/core/jupiter/response',
            responseEvent
          );
        } else if (test) {
          svs.events.unsubscribe(responseHandler);
          responseHandler = svs.events.subscribe(
            '/core/jupiter/response',
            responseEvent
          );
          START_TIME_FOR_SHOWING_MESSAGE = 10 * 1000;
          SESSION_TIME = 40 * 1000;
          SAFETY_MARGIN = 10 * 1000;
        }
        updateSessionTimers();
      }

      function prolongSession() {
        svs.core.jupiter.get('/user/sessions');
      }

      function show(force) {
        var currentTime = new Date().getTime();
        if (sessionEndTime - currentTime > 2 * SAFETY_MARGIN || force) {
          logger.info('Showing session end message');
          if (svs.core.detect.feature('ft-new-dialog')) {
            var _dialog = new svs.components.dialog.Confirm({
              icon: 'rest',
              branding: svs.core.detect.tenant('tb')
                ? svs.components.dialog.branding.TUR
                : svs.components.dialog.branding.SPORT,
              title: 'Är du kvar?',
              message: [
                {
                  type: svs.components.dialog.message.TEXT,
                  text: 'Du kommer snart bli utloggad på grund av inaktivitet.'
                }
              ],
              actions: [
                {
                  title: 'Logga ut',
                  callback: function() {
                    clearTimeout(closeMsgTimeoutID);
                    logger.info('User ended session.');
                    svs.core.userSession.logout();
                  }
                },
                {
                  title: 'Stanna kvar',
                  callback: function() {
                    clearTimeout(closeMsgTimeoutID);
                    logger.info('User prolonged session.');
                    prolongSession();
                    _dialog.close();
                  }
                }
              ]
            });
            svs.components.dialog.api.add(_dialog); 
          } else {
            svs.components.MessageBox.show({
              type: svs.components.MessageBox.Type.INFO,
              title: 'Är du kvar?',
              message: 'Du kommer snart bli utloggad på grund av inaktivitet',
              buttons: [
                {
                  type: svs.components.MessageBox.ButtonType.ABORT,
                  text: 'Logga ut',
                  callback: function() {
                    clearTimeout(closeMsgTimeoutID);
                    logger.info('User ended session.');
                    svs.core.userSession.logout();
                  }
                },
                {
                  type: svs.components.MessageBox.ButtonType.INFO,
                  text: 'Stanna kvar',
                  callback: function() {
                    clearTimeout(closeMsgTimeoutID);
                    logger.info('User prolonged session.');
                    prolongSession();
                  }
                }
              ]
            });
          }

          if (isNativeApp) {
            closeMsgTimeoutID = window.setTimeout(
              checkAndCloseMessage,
              Math.min(
                CHECK_SESSION_END_TIME,
                sessionEndTime - currentTime - SAFETY_MARGIN
              )
            ); 
          } else {
            closeMsgTimeoutID = window.setTimeout(
              close,
              sessionEndTime - currentTime - SAFETY_MARGIN
            );
          }
        } else {
          logger.info(
            'Not showing session end message, too short time: ' +
            parseInt((sessionEndTime - currentTime) / 1000, 10) +
            ' s'
          );
        }
      }
      function close() {
        logger.info('Closing message box without user interaction');
        svs.components.MessageBox.close();
      }
      init();
      return {
        init: init,
        prolongSession: prolongSession,
        responseEvent: responseEvent,
        getShowMsgTimeoutID: function() {
          return showMsgTimeoutID;
        }, 
        getSessionEndTime: function() {
          return sessionEndTime;
        }, 
        getLogger: function() {
          return logger;
        }, 
        show: show,
        close: close
      };
    })();
})(svs);

 })(window);